import { META_FALLBACK_IMAGE } from '@scentregroup/shared/constants'
import { makeSchemaImageUrls } from '@scentregroup/shared/hub-components/cloudinary-image/helpers/make-image-url'
import { NewsArticle, WithContext } from 'schema-dts'
import { ContentDetail } from '../get-content-detail'
import { toDateString } from '../to-date-string'

export function getNewsArticleStructuredDataFromContent(
  content:
    | ContentDetail['story']
    | ContentDetail['news']
    | ContentDetail['nationalNews'],
  canonicalUrl: string
): WithContext<NewsArticle> {
  const image = content.heroImageSet?.master?.url || META_FALLBACK_IMAGE
  const domain = new URL(canonicalUrl).host

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    '@id': `${canonicalUrl}#newsarticle`,
    headline: content.title,
    image: makeSchemaImageUrls(image),
    datePublished: toDateString(content.sys.firstPublishedAt),
    dateModified: toDateString(content.sys.publishedAt),
    author: {
      '@type': 'Organization',
      name: 'Westfield',
      url: `https://${domain}/`,
    },
  }
}
